
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/customization/approaches",
      function () {
        return require("private-next-pages/joy-ui/customization/approaches.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/customization/approaches"])
      });
    }
  